import React from "react";
import HelmetComponent from "./HelmetComponent";

function PrivacyPolicy(props) {
  return (
    <div className=" min-h-screen flex flex-col justify-between">
      <HelmetComponent
        title="Akerayu | Privacy Policy"
        description="Akerayu Privacy Policy Updated May 20, 2024 1. Information We Collect 1.1 Information Needed to Use the Akerayu Platform [...] Read More..."
        imageUrl="https://akerayu.com/emailImages/logo.png"
        pageUrl="https://akerayu.com/privacy-policy"
        type="website"
        robots="index, follow"
      />

      <div className="w-7/12 max-sm:w-full m-auto">
        <div className="max-w-3xl mx-auto px-4 py-8">
          <h1 className="text-3xl font-bold mb-4 text-main-orange">
            Akerayu Privacy Policy
          </h1>
          <p className="mb-4">Updated May 20, 2024</p>

          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-2">
              1. Information We Collect
            </h2>
            <p className="mb-2">
              1.1 Information Needed to Use the Akerayu Platform
            </p>
            <ul className="list-disc list-inside mb-4">
              <li>Your email address</li>
              <li>Your name</li>
              <li>Your password</li>
            </ul>
            <p className="mb-2">1.2 Information You Choose to Give Us</p>
            <ul className="list-disc list-inside mb-4">
              <li>Your phone number (required for listing a property)</li>
            </ul>
            <p className="mb-2">
              Additionally, users may choose to provide the following optional
              information on their profile:
            </p>
            <ul className="list-disc list-inside mb-4">
              <li>Date of Birth (DOB)</li>
              <li>Gender</li>
              <li>City</li>
              <li>Country</li>
              <li>Social media contacts</li>
            </ul>
            <p className="mb-2">
              1.3 Information Automatically Collected by Using the Akerayu
              Platform
            </p>
            <ul className="list-disc list-inside mb-4">
              <li>Your IP address</li>
              <li>Your GPS location (if you provide consent)</li>
              <li>Other device information</li>
            </ul>
          </div>

          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-2">
              2. How We Use Your Information
            </h2>
            <ul className="list-disc list-inside mb-4">
              <li>Provide and improve our services</li>
              <li>Communicate with you about your account and listings</li>
              <li>Customize your experience on the Site</li>
              <li>Analyze usage of the Site</li>
              <li>Comply with legal obligations</li>
            </ul>
          </div>

          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-2">
              3. Information Sharing
            </h2>
            <p className="mb-2">
              We do not sell, trade, or otherwise transfer your personal
              information to third parties without your consent, except as
              described below:
            </p>
            <ul className="list-disc list-inside mb-4">
              <li>
                With service providers who assist us in operating the Site
              </li>
              <li>
                To comply with legal requirements, such as responding to
                subpoenas or court orders
              </li>
              <li>In connection with a merger, sale, or asset transfer</li>
            </ul>
          </div>

          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-2">4. Cookies</h2>
            <p className="mb-2">
              Akerayu uses cookies to enhance your browsing experience and
              provide personalized features. Cookies are small pieces of data
              stored on your device that help us remember information about your
              visit and preferences, such as your login status and site
              preferences.
            </p>
            <p className="mb-2">
              You can control or disable cookies through your browser settings.
              However, please note that disabling cookies may affect certain
              features and functionality of Akerayu.
            </p>
            <p className="mb-2">
              By continuing to use our website, you consent to the use of
              cookies as described in this Privacy Policy.
            </p>
          </div>

          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-2">5. Your Choices</h2>
            <p className="mb-2">
              You can update or delete your account information at any time by
              logging into your account settings. You can also opt out of
              receiving promotional communications from us by following the
              instructions in those communications.
            </p>
          </div>

          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-2">6. Data Security</h2>
            <p className="mb-2">
              Although no system can be entirely foolproof, we are committed to
              maintaining the security of your information. We regularly update
              and enhance our administrative, and technical measures to
              safeguard your data against unauthorized access, loss, alteration,
              or destruction.
            </p>
          </div>

          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-2">
              7. Changes to this Privacy Policy
            </h2>
            <p className="mb-2">
              We may update this Privacy Policy from time to time. If we make
              material changes, we will notify you by posting a notice on the
              Site or by sending you an email.
            </p>
          </div>

          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-2">8. Contact Us</h2>
            <p className="mb-2">
              If you have any questions or concerns about this Privacy Policy,
              please contact us. Contact Akerayu Support.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
